import React, { useEffect, useState, useCallback } from "react";
import { sfx } from "./citySfx";

const TIPS = [
  "Never pay to see your own score. AnnualCreditReport.com is free, weekly.",
  "Utilization under 10% on statement day is the cheapest points you'll ever earn.",
  "An ATM fee on a $20 withdrawal is a 30% APR. Walk to your own bank.",
  "Autopay the minimum, then pay the rest manually. Never miss, never overdraft.",
  "Old accounts are gold. Don't close the card you opened in 2009.",
];
const FEE = 6;

const Key = ({ children, onClick, tone = "", testid }) => (
  <button data-testid={testid} onClick={onClick} className={`cq-px text-[9px] sm:text-[11px] h-10 border border-slate-600 active:translate-y-px ${tone || "bg-slate-200 text-slate-900 hover:bg-white"}`}>{children}</button>
);

export function Atm({ coins, name, onDeposit, onWithdraw }) {
  const [screen, setScreen] = useState("insert");
  const [pin, setPin] = useState("");
  const [msg, setMsg] = useState([]);
  const [bills, setBills] = useState(false);
  const [envelope, setEnvelope] = useState(false);
  const [deposited, setDeposited] = useState(false);

  const show = useCallback((lines, next, ms) => { setMsg(lines); setScreen("msg"); if (next) setTimeout(() => setScreen(next), ms || 1600); }, []);

  const submitPin = useCallback((p) => {
    if (p.length !== 4) return;
    sfx.click();
    show(["VERIFYING PIN", "PLEASE WAIT ▮▮▮"], null);
    setTimeout(() => {
      if (p === "0417") {
        setScreen("override"); setBills(true); sfx.win();
        setTimeout(() => { onDeposit(500); setBills(false); setMsg(["VAULT OVERRIDE ACCEPTED", "", "500 QUACK COINS", "CREDITED TO YOUR ACCOUNT", "", "THIS SESSION WAS NOT LOGGED.", "(IT WAS ABSOLUTELY LOGGED.)"]); setScreen("msg"); setTimeout(() => setScreen("menu"), 3200); }, 2600);
      } else setScreen("menu");
    }, 1200);
    setPin("");
  }, [onDeposit, show]);

  const press = useCallback((k) => {
    if (screen !== "pin") return;
    if (k === "C") { setPin(""); sfx.click(); return; }
    if (k === "E") { submitPin(pin); return; }
    if (pin.length < 4) { setPin((p) => p + k); sfx.step?.(false); }
  }, [screen, pin, submitPin]);

  useEffect(() => {
    const kd = (e) => { if (/^[0-9]$/.test(e.key)) press(e.key); else if (e.key === "Enter") press("E"); else if (e.key === "Backspace") { setPin((p) => p.slice(0, -1)); e.preventDefault(); } };
    window.addEventListener("keydown", kd); return () => window.removeEventListener("keydown", kd);
  }, [press]);

  const withdraw = (n) => {
    if (coins < n + FEE) { show(["INSUFFICIENT FUNDS", "", `NEED ${n + FEE} COINS`, `(${n} + ${FEE} IN ATM FEES)`, "", "THAT FEE IS A 30% APR", "ON A $20 WITHDRAWAL."], "menu", 3200); return; }
    show(["OUT-OF-NETWORK FEE: 3.5c", "YOUR BANK'S FEE: 2.5c", "", `DISPENSING ${n} COINS…`], null);
    setBills(true);
    setTimeout(() => { setBills(false); onWithdraw(FEE); show([`${n} COINS DISPENSED`, `${FEE} COINS IN FEES — GONE.`, "", "THE COINS ARE STILL YOURS.", "THE FEE ISN'T. LESSON LEARNED?"], "menu", 3200); }, 1800);
  };
  const deposit = () => {
    setEnvelope(true); show(["INSERT ENVELOPE ▮", "", "PROCESSING DEPOSIT…"], null);
    setTimeout(() => { setEnvelope(false); if (!deposited) { setDeposited(true); onDeposit(1); show(["ENVELOPE ACCEPTED", "", "CONTENTS: 1 COIN", "AND A SHREDDED 29.99% APR MAILER", "", "+1 COIN CREDITED"], "menu", 3000); } else show(["ENVELOPE ACCEPTED", "", "CONTENTS: LINT", "", "NOTHING CREDITED"], "menu", 2400); }, 1800);
  };
  const statement = () => show([`QUACK BANK · MINI STATEMENT`, `ACCT: ${(name || "DUCK").toUpperCase()}`, new Date().toLocaleString(), "", `BALANCE: ${coins} COINS`, "RECENT: COFFEE −3 · QUIZ +5", "TRADELINE HOLD · DISPUTE WIN +2", "", "NO OVERDRAFTS. PROUD OF YOU."], "menu", 4500);

  const lines = screen === "insert" ? ["QUACK BANK 24HR ATM", "", "WELCOME", "", "PLEASE INSERT YOUR CARD ▼"]
    : screen === "pin" ? ["ENTER YOUR 4-DIGIT PIN", "", "* ".repeat(pin.length) + "_ ".repeat(4 - pin.length), "", "PRESS ENTER WHEN DONE"]
    : screen === "menu" ? ["SELECT A TRANSACTION", "", `HELLO, ${(name || "DUCK").toUpperCase()}`, `BALANCE: ${coins} COINS`]
    : screen === "override" ? ["*** MAINTENANCE MODE ***", "", "VAULT OVERRIDE 0417", "OPENING CASH CASSETTE", "", "COUNTING… ▮▮▮▮▮▮"]
    : msg;

  return (
    <div className="grid md:grid-cols-[1fr_220px] gap-4" data-testid="atm-sim">
      <div className="bg-[#0f766e] border-4 border-[#0b4f4a] p-4 rounded-sm">
        <p className="cq-px text-[8px] text-amber-200 text-center mb-3">QUACK BANK · ATM #0208-B</p>
        <div className="relative bg-[#020617] border-4 border-slate-700 p-4 min-h-[190px]" data-testid="atm-screen">
          <div className="absolute inset-0 pointer-events-none opacity-20" style={{ background: "repeating-linear-gradient(0deg, transparent 0 2px, rgba(74,222,128,0.25) 2px 3px)" }} />
          {lines.map((l, i) => <p key={i} className="cq-px text-[8px] sm:text-[9px] text-emerald-300 leading-[1.9] whitespace-pre" data-testid={`atm-line-${i}`}>{l || " "}</p>)}
          {screen === "menu" && (
            <div className="grid grid-cols-2 gap-2 mt-3">
              {[["BALANCE", () => show([`AVAILABLE BALANCE`, "", `${coins} QUACK COINS`, "", "CREDIT LINE: WHATEVER YOUR", "SCORE SAYS IT IS. GO EARN IT."], "menu", 3000), "atm-balance"], ["WITHDRAW", () => setScreen("withdraw"), "atm-withdraw"], ["DEPOSIT", deposit, "atm-deposit"], ["MINI STATEMENT", statement, "atm-statement"], ["CREDIT TIP", () => show(["TODAY'S TIP", "", TIPS[Math.floor(Math.random() * TIPS.length)]], "menu", 4000), "atm-tip"], ["EJECT CARD", () => { sfx.door(); setScreen("insert"); }, "atm-eject"]].map(([l, fn, tid]) => (
                <button key={l} data-testid={tid} onClick={fn} className="cq-px text-[7px] sm:text-[8px] text-left text-emerald-200 border border-emerald-500/40 px-2 py-1.5 hover:bg-emerald-500/10">› {l}</button>
              ))}
            </div>
          )}
          {screen === "withdraw" && (
            <div className="grid grid-cols-2 gap-2 mt-3" data-testid="atm-withdraw-amounts">
              {[5, 10, 20, 50].map((n) => <button key={n} data-testid={`atm-amt-${n}`} onClick={() => withdraw(n)} className="cq-px text-[8px] text-emerald-200 border border-emerald-500/40 px-2 py-1.5 hover:bg-emerald-500/10">› {n} COINS</button>)}
              <button data-testid="atm-withdraw-back" onClick={() => setScreen("menu")} className="cq-px text-[8px] text-slate-300 border border-slate-600 px-2 py-1.5 col-span-2">‹ BACK</button>
            </div>
          )}
          {screen === "insert" && <button data-testid="atm-insert-card" onClick={() => { sfx.click(); setScreen("pin"); }} className="mt-3 cq-px text-[8px] bg-amber-400 text-slate-950 px-3 py-2 hover:bg-amber-300 cq-blink">INSERT CARD</button>}
        </div>
        <div className="flex items-center justify-between mt-3">
          <div className="w-28 h-3 bg-slate-950 border border-slate-600 relative overflow-hidden" title="card slot"><div className={`absolute inset-y-0 left-0 w-20 bg-cyan-400 transition-transform duration-700 ${screen === "insert" ? "-translate-x-2" : "translate-x-28"}`} /></div>
          <div className="w-40 h-5 bg-slate-950 border border-slate-600 relative overflow-hidden" data-testid="atm-cash-slot">
            {bills && [0, 1, 2, 3, 4].map((i) => <div key={i} className="absolute top-0.5 h-3 w-8 bg-emerald-400 border border-emerald-700 cq-bill" style={{ left: 4 + i * 26, animationDelay: `${i * 0.25}s` }} />)}
            {envelope && <div className="absolute top-0.5 left-10 h-3 w-16 bg-amber-100 border border-amber-500 cq-bill" />}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-1.5 content-start" data-testid="atm-keypad">
        {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((k) => <Key key={k} onClick={() => press(k)} testid={`atm-key-${k}`}>{k}</Key>)}
        <Key onClick={() => press("C")} tone="bg-rose-500 text-white hover:bg-rose-400" testid="atm-key-clear">CLR</Key>
        <Key onClick={() => press("0")} testid="atm-key-0">0</Key>
        <Key onClick={() => press("E")} tone="bg-emerald-500 text-slate-950 hover:bg-emerald-400" testid="atm-key-enter">ENT</Key>
        <p className="col-span-3 cq-px text-[6px] text-slate-400 leading-relaxed mt-2">Any 4-digit PIN opens your account. Type on your keyboard too. Fees are simulated — coins withdrawn stay yours, fees don't.</p>
      </div>
    </div>
  );
}
